import Brick from './Brick';

/** Class representing a workflow brick to
 * update a user.
 *
 * [server_side]
 */
class UserUpdateBrick extends Brick {}

export default UserUpdateBrick;
